import http from './http';

/**
 * @param {string} tenantId
 * @return {Promise<{senderName: string, senderEmail: string, clientId: string}>}
 */
export default async function getTenantSettings(tenantId) {
  try {
    const { data } = await http.get(`/onboarding/settings/tenants/${tenantId}`);

    const { docSignatureClientId, ...rest } = data.data;
    return {
      ...rest,
      clientId: docSignatureClientId,
    };
  } catch (e) {
    // ignore not found
    if (e?.response?.status === 404) {
      return {};
    }

    throw new Error(e?.response?.error?.message || e);
  }
}
